import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useClientExerciseFrequency } from './clientExerciseFrequencyApi';
import { LoadingState } from '../../components/common/LoadingState';
import { ApiErrorFallback } from '../../components/common/ApiErrorFallback';

interface ExerciseFrequencyChartProps {
  clientId: string;
}

export function ExerciseFrequencyChart({ clientId }: ExerciseFrequencyChartProps) {
  const { data, isLoading, error, refetch } = useClientExerciseFrequency(clientId);

  if (isLoading) {
    return <LoadingState message="Loading exercise data..." />;
  }

  if (error) {
    return <ApiErrorFallback error={error} onRetry={refetch} />;
  }

  if (!data || data.length === 0) {
    return <p className="text-muted-foreground">No exercise data available.</p>;
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data} layout="vertical">
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis type="number" />
        <YAxis type="category" dataKey="exerciseName" width={150} />
        <Tooltip />
        <Bar dataKey="count" fill="#8884d8" />
      </BarChart>
    </ResponsiveContainer>
  );
}